import * as types from "./actionTypes";

export const setKingspanReadingLoading = (isLoading) => {
  return {
    type: types.SET_KINGSPAN_READING_LOADING,
    payload: isLoading,
  };
};

export const setSOPLoading = (formName) => {
  return {
    type: types.SET_SOP_LOADING,
    payload: formName,
  };
};

export const markDocumentReadKingspan = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_KINGSPAN,
  payload: documentFilename,
});

export const postSOPKingspan = (formName, formContent) => ({
  type: types.POST_SOP_KINGSPAN,
  payload: { formName, formContent },
});

export const postSOPDocumentSuccess = (formName) => ({
  type: types.POST_SOP_DOCUMENT_SUCCESS,
  payload: formName,
});

export const setKingspanAssessmentLoading = (isLoading) => {
  return {
    type: types.KINGSPAN_ASSESSMENT_IS_LOADING,
    payload: isLoading,
  };
};

export const kingspanAssessmentSubmitted = (results) => ({
  type: types.KINGSPAN_ASSESSMENT_SUBMITTED,
  payload: results,
});

export const submitKingspanAssessment = (formName, formContent) => ({
  type: types.SUBMIT_KINGSPAN_ASSESSMENT,
  payload: { formName, formContent },
});
